import { cn } from '@lib/utils';

interface TitleProps {
  title: React.ReactNode;
  className?: string;
}

function Title({ title, className }: TitleProps) {
  const baseClassName =
    'text-[#2B2E33] text-2xl font-semibold leading-8 tracking-[-0.464px] md:text-4xl md:leading-[44px] md:tracking-[-0.784px]';

  return <h2 className={cn(baseClassName, className)}>{title}</h2>;
}

export default Title;
